import React, { useState, useEffect, useRef } from 'react'
// import PropTypes from 'prop-types'
import { TextField, Modal } from '@material-ui/core'
import { useStyles } from '../MaterialUiModal'
import BootstrapAlert from '../element/BootstrapAlert'
import { Autocomplete } from '@material-ui/lab'

export default function WorkflowModal (
  modalOpen,
  generalUsers,
  managers,
  selectingUsers,
  onSubmit
) {
  const classes = useStyles()
  const [valueG, setValueG] = useState(null)
  const [valueM, setValueM] = useState(null)
  const userMapRef = useRef(
    new Map(generalUsers.map((user) => [user.id, user]).concat(managers.map((user) => [user.id, user])))
  )

  useEffect(() => {
    setValueG(
      (selectingUsers ?? [])
        .filter((u) => !u.is_manager && userMapRef.current.has(u.id))
        .map((u) => userMapRef.current.get(u.id))
    )
    setValueM(
      (selectingUsers ?? [])
        .filter((u) => u.is_manager && userMapRef.current.has(u.id))
        .map((u) => userMapRef.current.get(u.id))
    )
  }, [selectingUsers])

  function onClose () {
    setValueG([])
    setValueM([])
    onSubmit(null)
  }

  function onAddClick () {
    onSubmit((valueG ?? []).concat(valueM ?? []))
    setValueG([])
    setValueM([])
  }

  return (
    <Modal
      className={classes.modal}
      open={modalOpen}
      onClose={onClose}>
      <div className={classes.paper}>
        <div className="">
          <BootstrapAlert class="info">
            <div>
              下のリストから承認者を選ぶと承認ルートに追加されます。<br/>
              並列承認の設定が可能です：一度に複数の承認者を設定できます。誰か1名が承認すれば次レベルの承認者に申請が回ります。
            </div>
          </BootstrapAlert>
          <div className="d-flex flex-column">
            <div className='my-3 p-1 bg-3 text-white'>承認者</div>
            <Autocomplete
              multiple={true}
              id="select-general-user"
              options={generalUsers} // filterNotInMembers(users)}
              value={valueG}
              getOptionLabel={(option) => `${option.name} - ${option.department ? option.department.name : ''}`}
              renderInput={(params) => <TextField {...params} label="氏名の一部を入力" variant="outlined" />}
              getOptionSelected={(option, value) => option.id === value.id}
              onChange={(e, value) => setValueG(value)}
            />
            <div className='my-3 p-1 bg-4 text-white'>管理承認者</div>
            <Autocomplete
              multiple={true}
              id="select-general-user"
              options={managers} // filterNotInMembers(users)}
              value={valueM}
              getOptionLabel={(option) => `${option.name} - ${option.department ? option.department.name : ''}`}
              renderInput={(params) => <TextField {...params} label="氏名の一部を入力" variant="outlined" />}
              getOptionSelected={(option, value) => option.id === value.id}
              onChange={(e, value) => setValueM(value)}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-6">
            <button type='button' className='btn btn-outline-secondary' onClick={onClose}>
              キャンセル
            </button>
          </div>
          <div className="col-6 text-right">
            <button type='button' className='btn bg-8' onClick={onAddClick}>
              追加
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
